export const authUrl = '/auth/local';
export const placesUrl = '/places';

//API urls
const localApiUrl = 'http://localhost:1337';

const hostedApiUrl = 'https://holidaze-strapi.onrender.com';

export const baseUrl = hostedApiUrl;
